import vibrancyReducer from './vibrancy/reducerSlice'
import AIMetricReducer from './AIMetricOT/reducerSlice'

const reducers = {
  vibrancy: vibrancyReducer,
  AIMetric: AIMetricReducer,
}

export default reducers
